import { emulatorScreen, mobileScreen } from "../../utils/styleUtils";

const styles = (theme) => ({
  modalContainer: {
    height: "100%",
    padding: "3rem",
    flexDirection: "column"
  },

  modalDescription: {
    color: "#003e4c",
    fontWeight: "600",
    fontFamily: "'Rubik', sans-serif",
    fontSize: 40,
    letterSpacing: "1px",
    padding: "20px 10px 40px 10px",
    [mobileScreen(theme)]: {
      fontSize: 24,
      padding: "20px 10px 40px 10px",
    },
  },

  nextButton: {
    color: "#fff",
    backgroundColor: "#00b1d9",
    fontSize: "40px",
    fontWeight: "500",
    padding: "0px 25px",
    borderRadius: "0px",
    fontFamily: "'Oswald', sans-serif",
    "&:hover": {
      backgroundColor: "#056f8a",
    },
    [mobileScreen(theme)]: {
      fontSize: 24,
    },
  },
});
export default styles;
